import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PagamentosService } from 'src/app/services/pagamentos.service';
import { StatusAgendamentoService } from 'src/app/services/status-agendamento.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabGroup } from '@angular/material';

@Component({
  selector: 'app-pagamento-client',
  templateUrl: './pagamento-client.component.html',
  styleUrls: ['./pagamento-client.component.scss']
})
export class PagamentoClientComponent implements OnInit {
  pagamentoForm: FormGroup;
  horarioSel: any = {};
  userData: any = {};
  token: string;
  pago: boolean = false;
  anosExpiracao: any = [];
  mesesExpiracao: any = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  pagando: boolean = false;

  params: any = {
    "id": 0,
    "nome": "",
    "cpfCnpj": "",
    "valor": 0,
    "descricao": "",
    "cartao": {},
    "comprador": {}
  };

  @ViewChild('paymentTabs') paymentTabs: MatTabGroup
  @Input() stepper: any;

  constructor(
    private pagamentos: PagamentosService,
    private statusAgendamentoService: StatusAgendamentoService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private paymentService: PagamentosService,
    public schedulingStatusService: StatusAgendamentoService
  ) {
    this.pagamentoForm = this.formBuilder.group({
      nomeCartao: ['', Validators.required],
      numeroCartao: ['', Validators.required],
      mesExpiracaoCartao: ['', Validators.required],
      anoExpiracaoCartao: ['', Validators.required],
      ccvCartao: ['', Validators.required],
      nomeComprador: ['', Validators.required],
      emailComprador: ['', Validators.required],
      cpfCnpjComprador: ['', Validators.required],
      cepComprador: ['', Validators.required],
      enderecoComprador: ['', Validators.required],
      enderecoNumeroComprador: ['', Validators.required],
      telefoneComprador: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.checkIfPixPaymentRunning()
  }

  isPixRunning: boolean = false

  checkIfPixPaymentRunning () {
    this.isPixRunning = !!sessionStorage.getItem('pixPayment')

    if(!this.isPixRunning) return

    this.paymentTabs.selectedIndex = 1
  }

  canceledPix: boolean = false
  chargeId: number

  cancelPayment (goBack: boolean) {
    const paymentInfo = sessionStorage.getItem('pixPayment')
    if(!paymentInfo) {
      sessionStorage.removeItem('selecaoObj')
      window.location.reload()
      return
    }
    sessionStorage.removeItem('pixPayment')
    const jsonPayment = JSON.parse(paymentInfo)
    this.paymentService.deleteCharge(jsonPayment.charge_id).subscribe(resp => {
      if(goBack) return

      sessionStorage.removeItem('selecaoObj')
      window.location.reload()
    })
  }

  onPagamento = this.statusAgendamentoService.stepStatusChange.subscribe(value => {
    if (value.selectedStep && value.selectedStep.label == "stepPagamento") {
      this.onDefineParametros();
      this.onGeraAnoExpiracaoCartao();
    }
  });

  onPagar = () => {
    this.pagando = true;
    if (this.pago || this.pagamentoForm.invalid) {
      this.snackBar.open("Preencha os formulários corretamente e tente novamente.", 'Ok', {
        duration: 5000,
        panelClass: ['error-snackbar']
      });
      this.pagando = false;
      return false;
    }

    this.pagamentos.gerarCobranca(this.params, this.token)
      .subscribe(
        (response: any) => {
          if(response.error) {
            this.snackBar.open(response.error.Erro[0].description, 'Ok', {
              duration: 5000,
              panelClass: ['error-snackbar']
            });
            this.pagando = false;
            return false;
          }

          if(response.body.status == "CONFIRMED") {

            this.statusAgendamentoService.setInfoPagamento(response.body);

            this.snackBar.open('Pagamento confirmado com sucesso.', 'Ok', {
              duration: 5000,
              panelClass: ['success-snackbar']
            });

            this.stepper.next();
          }

          this.pagando = false;
          this.pago = true;
        },
        (err) => {
          if(err.error) {
            this.snackBar.open(err.error.Erro[0].description, 'Ok', {
              duration: 5000,
              panelClass: ['error-snackbar']
            });
            this.pagando = false;
          }
        }
      );
  };

  onContinuar = () => {
    if (this.pago) {
      this.stepper.next();
    }
  };

  onDefineParametros = () => {
    this.horarioSel = JSON.parse(sessionStorage.getItem('horarioSel'));
    this.userData = JSON.parse(sessionStorage.getItem('userData'));

    this.token = this.userData.token;

    this.params.id = this.userData.id;
    this.params.nome = this.userData.nome;
    this.params.cpfCnpj = this.userData.cpf;
    this.params.valor = parseFloat(this.horarioSel.valor).toFixed(2);
    this.params.descricao = `${this.horarioSel.agenda}, ${this.horarioSel.data.replace('-', '/').replace('-', '/')} ${this.horarioSel.hora.hora}
    - ${this.horarioSel.procedimentoNome} - Tel: ${this.userData.fone} - E-mail: ${this.userData.email}`;

    this.params.comprador.nome = this.userData.nome;
    this.params.comprador.cpfCnpj = this.userData.cpf;
    this.params.comprador.email = this.userData.email;
    this.params.comprador.endereco = this.userData.logradouro;
    this.params.comprador.cep = this.userData.cep;
    this.params.comprador.enderecoNumero = this.userData.numero;
    this.params.comprador.telefone = this.userData.fone;

    if(this.userData.responsaveis) {
      const responsaveisArray = JSON.parse(this.userData.responsaveis)
      if(responsaveisArray.length > 0) {
        this.params.comprador.nome = responsaveisArray[0].nome
        this.params.comprador.cpfCnpj = responsaveisArray[0].cpf
      }
    }
  };

  onGeraAnoExpiracaoCartao = () => {
    this.anosExpiracao = [];

    const hoje = new Date();
    const ano = hoje.getFullYear();

    for(let i = 0; i < 15; i++) {
      this.anosExpiracao.push(ano + i)
    }
  };

  onVoltarClick() {
    this.stepper.previous();
  };

}
